

import React, { useEffect, useState } from 'react';
import { Provider } from 'react-redux';
import { setupStore, StoreType } from '../redux/store';
import { setupAxiosInterceptors } from '../settings/api';

export default function StoreProvider({ children }: { children: React.ReactNode }) {
    const [store, setStore] = useState<StoreType | null>(null);
    useEffect(() => {
        (async () => {
            const createdStore = await setupStore();
            setStore(createdStore);
            // @ts-expect-error
            setupAxiosInterceptors(createdStore);
        })();
    }, []);
    if (!store) return null;
    return (
        <Provider store={store}>
            {children}
        </Provider>
    );
}